/** VUEX Project manager
 *
 * @requires Dau.js
 * @requires Project.js
 * @requires ProjectsAPI.js
 */
import { B2bHeaderC, ParentProject } from '@custom/_modules/ParentProject'
import { CrulesAPI, NextApiClient } from '@3cad/nextcore'
import { App } from '@3cad/nextcore'
import { utils } from '@3cad/nextcore'
import { ApplyReval } from '@3cad/nextcore'
const { loadJson } = utils;
export const parentPrjManager = {
    namespaced: true,
    state: new ParentProject(),

    // Get project object's properties
    getters: {
    },
    // Mutate project object
    mutations: {
        empty(state) {
            Object.assign(state, new ParentProject());
        },
        merge(state, data) {

            Object.assign(state, data);
        },
        mergeHeader(state, header) {

            // Is child
            if (header.NChild) {
                let idTemp = header.NChild;
                let childHead = state.b2bHeaderC.find(t => {
                    return t.NChild === idTemp;
                })
                if (!childHead) {
                    state.b2bHeaderC.push(header);
                } else {
                    Object.assign(childHead, header);
                }
            }
            // Is template
            else if (header.NTemplate) {
                let idTemp = header.NTemplate;
                let exTemp = state.b2bHeaderT.find(t => {
                    return t.NTemplate === idTemp;
                })

                if (!exTemp) {
                    state.b2bHeaderT.push(header);
                } else {
                    Object.assign(exTemp, header);
                }
            }
        },
        recompute(state, {data: data}) {
        }
    },
    // Async operations in project object
    actions: {
        /** Save project
         * @param context
         * @param clone Boolean - Clone project as new project
         * @param isOffer Boolean
         * @returns {Promise}
         */
        save(context, { clone = false, isOffer = false }) {
            return new Promise((resolve, reject) => {
                NextApiClient.com('projectsb2b', 'jB2BSave', {
                    jData: JSON.stringify(context.state.getJson())
                }, res => {
                    context.commit('merge', res);
                    resolve(res);
                }, err => {
                    reject(err);
                })
            });
        },
        /** Load project
         * @param context
         * @param data
         * @returns {Promise}
         */
        load(context, data) {
            return new Promise((resolve, reject) => {
                NextApiClient.com('projectsb2b', 'jB2BLoad', {
                    idParent: data.id
                }, res => {
                    context.commit('merge', res);
                    resolve(res);
                }, err => {
                    reject(err);
                })
            });
        },
        /** recompute prices
         * @param context
         * @param overwriteImg
         * @returns {Promise}
         */
        recompute(context, { overwriteImg: overwriteImg = true}) {
            return new Promise((resolve, reject) => {

            })
        },
        /** Set project status
         * @param context
         * @param prjId
         * @param status
         * @param toShop
         * @param toUser
         * @param extraData
         * @returns {Promise}
         */
        setStatus(context, {prjId, status, toShop = '', toUser = 0, extraData = ''}) {
            return new Promise((resolve, reject) => {
                /*ProjectsAPI.setstatus(prjId, status, toShop, toUser, extraData, json => {
                    if (json) {
                        context.commit('merge', json);
                        resolve(json);
                    }
                    else {
                        reject();
                    }
                });*/
            });
        },
        async saveTemplate(context, {
            prj,
            config
        }) {
            return new Promise((resolve, reject) => {
                let tmpPrj = prj.getJson();
                let prjName = tmpPrj.des
                let tempHead = prj.b2bHeaderT;
                if(!tempHead || !Object.keys(tempHead).length) {
                    tmpPrj.b2bHeaderT = {
                        NTemplate: 0,
                        IdTemplatePrj: 0,
                        IdParent: this.parentPrj.id,
                        frontendFeatureLocked: 0,
                        des: prjName,
                        qty: 1,
                        price: null,
                        isLocked: false,
                        specifyVariantCost: null
                    };
                }

                App.iCad.renderAllViews(prj, loadJson, config, (viewMaker) => {
                    NextApiClient.com(
                        "projectsb2b",
                        "jB2BTemplateSave",
                        {
                            jPrj: JSON.stringify(tmpPrj),
                            jView: JSON.stringify(viewMaker),
                        },
                        res => {
                            this.commit('project/merge', res)
                            resolve(res)
                        },
                        reject
                    );
                }, false, false, (tipo, data) => {
                    switch (tipo) {
                        case Eng3d_Callbacks.CB_EVALUATE_WALLS:
                            App.iCad.getCadWrapper().saveWalls();
                            CrulesAPI.cadCallBackEvalWalls(data);
                            break;
                        case Eng3d_Callbacks.CB_EVALUATE_TOPS:
                            this.$store.dispatch("project/cadCallBackEvalTop", {data});
                            break;
                        case Eng3d_Callbacks.CB_SCRIPT_QUOTE:
                            CrulesAPI.cadCallbackScriptQuote(data);
                            break;
                        case(Eng3d_Callbacks.DONWLOAD_PHOTOMATCH_IMG):
                            App.downloadPhotoMatchImg(data);
                            break;
                        default:
                            console.warn('Manage', tipo, data);
                            break;
                    }
                }, App.iCad.getCadWrapper());
            })
        },
        async saveChild(context, {
            prj,
            config,
            detach = false
        }) {
            return new Promise((resolve, reject) => {
                let tmpPrj = prj.getJson();
                // let json+ToSave = (detach || prj.b2bHeaderC.isDetached) ? tmpPrj : {b2bHeaderC: tmpPrj.b2bHeaderC};
                let jsonToSave = tmpPrj;

                let generateViews = () => {
                    return new Promise((resolve, reject) => {
                        // if(detach || prj.b2bHeaderC.isDetached) {
                        if(true) {
                            App.iCad.renderAllViews(prj, loadJson, config, resolve, false, false, (tipo, data) => {
                                switch (tipo) {
                                    case Eng3d_Callbacks.CB_EVALUATE_WALLS:
                                        App.iCad.getCadWrapper().saveWalls();
                                        CrulesAPI.cadCallBackEvalWalls(data);
                                        break;
                                    case Eng3d_Callbacks.CB_EVALUATE_TOPS:
                                        this.$store.dispatch("project/cadCallBackEvalTop", {data});
                                        break;
                                    case Eng3d_Callbacks.CB_SCRIPT_QUOTE:
                                        CrulesAPI.cadCallbackScriptQuote(data);
                                        break;
                                    case(Eng3d_Callbacks.DONWLOAD_PHOTOMATCH_IMG):
                                        App.downloadPhotoMatchImg(data);
                                        break;
                                    default:
                                        console.warn('Manage', tipo, data);
                                        break;
                                }
                            }, App.iCad.getCadWrapper());
                        } else {
                            resolve(null)
                        }
                    })
                }

                generateViews().then(views => {
                    NextApiClient.com(
                        "projectsb2b",
                        "jB2BChildSave",
                        {
                            jPrj: JSON.stringify(jsonToSave),
                            jView: views ? JSON.stringify(views) : '',
                        },
                        res => {
                            this.commit('project/merge', res)
                            resolve(res)
                        },
                        reject
                    );
                })
            })
        },
        async loadChild(context, {
            parentId,
            templateId,
            childId
        }) {
            return new Promise((resolve, reject) => {
                // delete this.state.project.b2bHeaderT;
                // this.state.project.b2bHeaderT = {};
                // this.state.project.b2bHeaderC = {};
                // this.state.project.b2bHeaderC = new B2bHeaderC();

                NextApiClient.com("projectsb2b", "jB2BChildLoad", {
                    idParent: parentId,
                    NTemplate: templateId,
                    NChild: childId
                }, response => {
                    // Same as common load project
                    this.commit('project/empty')
                    this.commit('project/merge', response)
                    this.state.project.isopen = true;

                    // Reval project
                    if(response.b2bHeaderC.variants && response.b2bHeaderC.variants.length) {
                        context.dispatch('revalChild', {
                            variants: this.state.project.b2bHeaderC.variants,
                            lastHistory: this.state.project.history[this.state.project.history.length - 1]
                        }).then(() => {
                            resolve(response)
                        }).catch(reject)
                    } else
                        resolve(response)
                }, reject);
            })
        },
        async getChildRefs(context, { childId }) {
            return new Promise((resolve, reject) => {
                NextApiClient.com("projectsb2b", "jB2BChildGetParentTemplate", {
                    idChildProject: childId
                }, resolve, reject);
            })
        },
        async revalChild(context, {
            variants,
            lastHistory
        }) {
            return new Promise((resolve, reject) => {
                let rows = [];
                let enabledVars = {};

                for(let i=0; i<variants.length; i++) {
                    rows.push({
                        cod: variants[i].codvar,
                        value: variants[i].option
                    })

                    enabledVars[variants[i].codvar] = true
                }

                let changes = ApplyReval.Changes.getChanges(
                    lastHistory.catalog,
                    lastHistory.currentModel,
                    lastHistory.currentModel,
                    null,
                    {
                        rows: rows
                    },
                    enabledVars
                );


                console.log(changes);
                App.projectManager
                    .calcReval(changes)
                    .then(resolve)
                    .catch(reject);
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/custom/epoq/_modules/ParentProjectStore.js